import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconUnmappedPromoGames: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.25 11.25H3.75C2.50736 11.25 1.5 12.2574 1.5 13.5C1.5 14.7426 2.50736 15.75 3.75 15.75H14.25C15.4926 15.75 16.5 14.7426 16.5 13.5C16.5 12.2574 15.4926 11.25 14.25 11.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 8.25C15.1569 8.25 16.5 6.90686 16.5 5.25C16.5 3.59314 15.1569 2.25 13.5 2.25C11.8431 2.25 10.5 3.59314 10.5 5.25C10.5 6.90686 11.8431 8.25 13.5 8.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 5.25L4.875 1.875L8.25 5.25L4.875 8.625L1.5 5.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
